var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Analytics",
    transform: "translate(-1068 -650)",
    stroke: "#ff7200"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 0,
    height: 0,
    rx: 5,
    transform: "translate(1068 650)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "index",
    d: "M174.236,264.809a2.954,2.954,0,0,0-2.411,4.671l-1.177.733a2.942,2.942,0,0,0-3.255-.065l-1.81-2.656a2.959,2.959,0,1,0-5.848,0l-2.088,2.639a2.972,2.972,0,1,0,1.567,1.239l1.587-2h0a2.944,2.944,0,0,0,3.655.04l1.667,2.438h0a2.959,2.959,0,1,0,5.688,0l1.875-1.167h0a2.959,2.959,0,1,0,.548-5.871ZM156.713,273.9a.959.959,0,1,1,.675-.281.956.956,0,0,1-.675.281Zm5.951-5.886a.959.959,0,1,1,.676-.281.956.956,0,0,1-.676.281Zm6.316,5.6a.959.959,0,1,1,.675-.281.956.956,0,0,1-.675.281Zm5.257-4.884a.959.959,0,1,1,.675-.281.957.957,0,0,1-.675.281Z",
    transform: "translate(920.275 397.92)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.ed0fb788374021deae6673569956d7d5.svg";
export { ForwardRef as ReactComponent };